import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';

const SrSecureTextLabel = ({ children }) => (
  <>
    <span style={{ fontSize: '10px', marginRight: '4px' }} role="img" aria-label="wave">
      &#128274;
    </span>
    <SrText font="greycliff" weight="600" size="13" color="grey400">
      {children}
    </SrText>
  </>
);

SrSecureTextLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

SrSecureTextLabel.displayName = 'SrSecureTextLabel';

export default SrSecureTextLabel;
